(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1178);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7274);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_metaConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7202);
// Modules



// Styles

// Constants

var Footer = function() {
    var items = [
        {
            label: "FAQ",
            route: "/faq"
        },
        {
            label: "Contact Us",
            route: "/contact-us"
        },
        {
            label: "Privacy Policy",
            route: "/privacy-policy"
        },
        {
            label: "Terms of Service",
            route: "/terms-of-service"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pagePad__x",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footer),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex--1",
                            style: {
                                maxWidth: 360
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "cursor--pointer",
                                        src: "/assets/icons/logoFull.svg?v=2",
                                        alt: "NamasPay logo",
                                        style: {
                                            height: 32
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "fontSize--h4 color--secondary marginTop--l3",
                                    style: {
                                        lineHeight: 1.5
                                    },
                                    children: _constants_metaConstants__WEBPACK_IMPORTED_MODULE_3__/* .META_INFO.LONG_DESC */ .f.LONG_DESC
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex--1 padLeft--l2",
                            style: {
                                maxWidth: 420,
                                color: "rgba(246, 246, 246, 1)"
                            },
                            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: item === null || item === void 0 ? void 0 : item.route,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "cursor--pointer display--block color--link ".concat(index > 0 ? "marginTop--l3" : "", " ").concat((_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerLink)),
                                        children: item === null || item === void 0 ? void 0 : item.label
                                    })
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        height: 1,
                        background: "rgba(255,255,255,0.1)",
                        marginTop: 80,
                        marginBottom: 80
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text__align--center color--secondary fontSize--h5 marginTop--l10",
                    children: "\xa9 Copyright 2023 Triotech Ltd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text__align--center color--secondary fontSize--h5 marginTop--l1",
                    children: "All rights reserved"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 9533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7274);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _elements_CTA__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1461);
/* harmony import */ var _utils_helperFunctions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8365);
// Modules



// Styles

// Components

// Utils

var Header = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBrowser = ref[0], setIsBrowser = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (true) setIsBrowser(true);
    }, []);
    var isDesktop = function() {
        if (!isBrowser) return true;
        var isMobile = "ontouchstart" in window; // likely mobile
        return !isMobile;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headerWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat((_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header), " pagePad__x"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "cursor--pointer",
                        src: "/assets/icons/logoFullBlack.svg",
                        alt: "NamasPay logo",
                        style: {
                            height: 56,
                            width: 296
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_CTA__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().downloadCTA),
                    type: "primary",
                    text: isDesktop() ? "Download Now" : "Download Now",
                    onAction: _utils_helperFunctions__WEBPACK_IMPORTED_MODULE_4__/* .onDownloadClick */ .No
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 1010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7274);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _elements_CTA__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1461);
/* harmony import */ var _utils_helperFunctions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8365);
/* harmony import */ var _constants_metaConstants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7202);
// Modules


// Styles

// Components

// Utils & Constants


var SupportSection = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBrowser = ref[0], setIsBrowser = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (true) setIsBrowser(true);
    }, []);
    var isDesktop = function() {
        if (!isBrowser) return true;
        var isMobile = "ontouchstart" in window; // likely mobile
        return !isMobile;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().supportContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sectionHeading textAlign--center--mobile flex--1",
                children: [
                    "We’re here",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "to help, 24x7"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().details), " flex--1"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().desc),
                    children: [
                        "Got questions? Our support team is available via chat or call anytime you need. Reach out to us at ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "mailto:".concat(_constants_metaConstants__WEBPACK_IMPORTED_MODULE_4__/* .META_INFO.EMAIL */ .f.EMAIL),
                            rel: "noreferrer",
                            style: {
                                color: "blue"
                            },
                            children: _constants_metaConstants__WEBPACK_IMPORTED_MODULE_4__/* .META_INFO.EMAIL */ .f.EMAIL
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SupportSection);


/***/ }),

/***/ 368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ allFAQs; }
/* harmony export */ });
var allFAQs = [
    {
        title: "Who can use NamasPay?",
        desc: "NamasPay is open to travellers from around the world. Currently, NamasPay can be used by citizens from the following countries:<br/><br/>\n                Argentina, Australia, Brazil, Canada, China, France, Germany, India, Indonesia, Italy, Japan, Mexico, Republic of Korea, Russia, Saudi Arabia, South Africa, T\xfcrkiye, United Kingdom (UK), United States of America (USA), European Union (EU) and African Union (AU)."
    },
    {
        title: "Is my country in European Union?",
        desc: "NamasPay can be used by citizens of following European Union countries:<br/><br/>\n                Austria, Belgium, Bulgaria, Croatia, Republic of Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovakia, Slovenia, Spain and Sweden."
    },
    {
        title: "Is my country covered in African Union?",
        desc: "NamasPay can be used by citizens of following African Union countries:<br/><br/>\n                Algeria, Angola, Benin, Botswana, Burkina Faso, Burundi, Cameroon, Cape Verde, Central Africa, Chad, Comoros, Congo, Democratic Republic of the Congo, Djibouti, Egypt, Equatorial Guinea, Eritrea, Eswatini, Ethiopia, Gabon, Gambia, Ghana, Guinea, Guinea-Bissau, Ivory Coast, Kenya, Lesotho, Liberia, Libya, Madagascar, Malawi, Mali, Mauritania, Mauritius, Morocco, Mozambique, Namibia, Niger, Nigeria, Rwanda, Sao Tome and Principe, Senegal, Seychelles, Sierra Leone, Somalia, South Africa, South Sudan, Sudan, Tanzania, Togo, Tunisia, Uganda, Western Sahara, Zambia, Zimbabwe."
    },
    {
        title: "Is NamasPay secure?",
        desc: "NamasPay focuses on the safety and security of your money by strictly adhering to regulatory guidelines by RBI &  NPCI. With NamasPay’s digital payments, not only do you get convenience, but you also avoid the risk of losing your cash or cards. Every transaction you make is device-lock protected. The app also constantly checks for fraudulent activity, thereby ensuring your money is safe within the app and while making payments."
    },
    {
        title: "What documents are required to set up my NamasPay wallet?",
        desc: "To set up your NamasPay wallet, you will be made to complete a physical verification which will require your passport and Visa."
    },
    {
        title: "Where can I spend with NamasPay?",
        desc: "Cabs, restaurants, online shopping, hotels, malls - you name it, NamasPay will help you pay it! Pay any merchant UPI ID with NamasPay while you travel across the country."
    },
    {
        title: "What are NamasPay's charges?",
        desc: "Here are all the charges that come with NamasPay - nothing more, nothing less.<br/><br/>\n                - One time set-up fee of INR ~1650<br/><br/>\n                - ~4% of your amount every time you add money<br/><br/>\n                - ~1% of your amount when you withdraw money"
    },
    {
        title: "How do I add money into my NamasPay wallet?",
        desc: "You can add money into your NamasPay wallet from any Mastercard or Visa card! Once entered in your currency, the money shall get added and stored as Rupees in your wallet, which you can then spend anywhere in India."
    },
    {
        title: "Can I deposit cash to add money into my NamasPay wallet?",
        desc: "We currently do not accept cash deposits to add money into your wallet. However, you can use any Mastercard or Visa card to transfer money into your wallet instead!"
    },
    {
        title: "How do you Scan and Pay?",
        desc: "With Scan and Pay, you can make a payment by simply scanning a merchant's QR code and entering the amount you would like to send!<br/><br/>\n                Here's how you can Scan and Pay:<br/><br/>\n                - Open your NamasPay app and click on 'Scan & Pay'<br/><br/>\n                - A scanner opens up, with which you can scan any merchant's QR code<br/><br/>\n                - Once scanned, enter the amount you wish to send to the merchant and click 'Pay'<br/><br/>\n                - That's it! You just made a payment using Scan and Pay."
    },
    {
        title: "How do you pay using your UPI ID?",
        desc: "On NamasPay, you can make payments online using your UPI ID! Here's how it works:<br/><br/>\n                - Once you reach the payments screen of the app or website you are shopping on, click on the 'Add new UPI ID' option while choosing your mode of payment<br/><br/>\n                - Enter your UPI ID, which can be copied from the home screen of your NamasPay app<br/><br/>\n                - Once entered, you can proceed to pay<br/><br/>\n                - You will then receive a request for the payment on your NamasPay app<br/><br/>\n                - Accept the payment request by clicking on 'Pay', and you're done!"
    }
];


/***/ }),

/***/ 1461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _CTA_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(653);
/* harmony import */ var _CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2__);
// Modules



// Styles

var CTA = function(param) {
    var className = param.className, type = param.type, leftImg = param.leftImg, text = param.text, rightImg = param.rightImg, onAction = param.onAction, disabled = param.disabled, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(className || "", " ").concat((_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default().customCta), " ").concat((_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[type] || "", " ").concat(disabled ? (_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : ""),
        style: style ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, style) : {},
        onClick: function() {
            if (onAction) onAction();
        },
        children: [
            leftImg,
            text,
            rightImg
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CTA);


/***/ }),

/***/ 1178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/HomeUI.module.scss
var HomeUI_module = __webpack_require__(7274);
var HomeUI_module_default = /*#__PURE__*/__webpack_require__.n(HomeUI_module);
// EXTERNAL MODULE: ./elements/CTA.js
var CTA = __webpack_require__(1461);
// EXTERNAL MODULE: ./components/Header.js
var Header = __webpack_require__(9533);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./components/SupportSection.js
var SupportSection = __webpack_require__(1010);
// EXTERNAL MODULE: ./utils/helperFunctions.js
var helperFunctions = __webpack_require__(8365);
// EXTERNAL MODULE: ./constants/faqConstants.js
var faqConstants = __webpack_require__(368);
;// CONCATENATED MODULE: ./constants/commonConstants.js
var upiUsages = [
    {
        title: "Pay anywhere in India",
        desc: "by scanning QR Codes at stores",
        img: "/assets/images/pay_anywhere.svg"
    },
    {
        title: "Use any Mastercard or Visa card",
        desc: "to add money into your wallet",
        img: "/assets/images/add_money_into_your_wallet.svg"
    },
    {
        title: "Make online payments",
        desc: "using your own UPI ID",
        img: "/assets/images/online_payments.svg"
    },
    {
        title: "Track all your spends ",
        desc: "while you travel and explore",
        img: "/assets/images/track_spends.svg"
    }
];
var upiFeatures = [
    {
        title: "UPI (Unified Payments Interface) is the most widely used payments system in India",
        img: "/assets/images/upi-usage1.png"
    },
    {
        title: "Over 260 million Indians use UPI, making it India's preferred mode of payment",
        img: "/assets/images/upi-usage2.png"
    },
    {
        title: "Pay for cabs, hotels, food, shopping - UPI is accepted everywhere",
        img: "/assets/images/upi-usage3.png"
    }
];
var quickFeatures = [
    {
        img: "/assets/icons/RBI.svg",
        title: "NamasPay follows all RBI (Reserve Bank of India) guidelines"
    },
    {
        img: "/assets/icons/Lock.svg",
        title: "All your transactions are protected with a device-lock"
    },
    {
        img: "/assets/icons/Scan.svg",
        title: "Avoid the risk of losing your cash and cards by using digital payments"
    }
];
var gettingStarted = [
    {
        title: "Download the NamasPay App ",
        desc: "Sign up with your international or new Indian number.",
        img: "/assets/icons/Download.svg"
    },
    {
        title: "Complete your physical verification",
        desc: "Our agents will come to you to verify your passport & Visa.",
        img: "/assets/icons/Verification.svg"
    },
    {
        title: "Add money and spend across India",
        desc: "Transfer money in your currency using any Mastercard or Visa card, and start paying in Rupees!",
        img: "/assets/icons/Wallet.svg"
    }
];
var acrossCountryList = [
    "Flights",
    "Hotels",
    "Cabs",
    "Restaurants & food orders",
    "Supermarkets",
    "Online shopping"
];

;// CONCATENATED MODULE: ./components/HomeUI.js
// Modules


// Styles

// Components




// Constants & Utils



var HomeUI = function() {
    var ref = (0,react.useState)(-1), openedFaqIndex = ref[0], setOpenedFaqIndex = ref[1];
    var ref1 = (0,react.useState)(false), isBrowser = ref1[0], setIsBrowser = ref1[1];
    var ref2 = (0,react.useState)(0), welcomeToTextIndex = ref2[0], setWelcomeToTextIndex = ref2[1];
    var welcomeToTextList = [
        "convenient payments",
        "NamasPay",
        "India"
    ];
    var arrayOf100Length = Array.from(Array(100).keys());
    var arrayOf1000Length = Array.from(Array(1000).keys());
    (0,react.useEffect)(function() {
        if (true) {
            setIsBrowser(true);
        }
        setInterval(function() {
            setWelcomeToTextIndex(function(prevState) {
                if (prevState === (welcomeToTextList === null || welcomeToTextList === void 0 ? void 0 : welcomeToTextList.length) - 1) return 0;
                return prevState + 1;
            });
        }, 2000);
    }, []);
    var isMobile = function() {
        if (!isBrowser) return true;
        var isMobile = "ontouchstart" in window; // likely mobile
        return isMobile;
    };
    var isDesktop = function() {
        if (!isBrowser) return true;
        var isMobile = "ontouchstart" in window; // likely mobile
        return !isMobile;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((HomeUI_module_default()).sec1, " pagePad__x"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HomeUI_module_default()).details,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (HomeUI_module_default()).pageTitle,
                                children: "Cashless UPI payments for foreign travellers in India"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "".concat((HomeUI_module_default()).desc, " marginTop--l3"),
                                children: "Scan & pay with UPI using your own digital wallet"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((HomeUI_module_default()).storeImagesWrapper, " display--flex flex__justifyContent--start flex__flow--wrap"),
                                children: [
                                    ((0,helperFunctions/* isAndroid */.Dt)() || !(0,helperFunctions/* isIOS */.gn)() || !isBrowser) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://play.google.com/store/apps/details?id=in.namaspay.app",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: (HomeUI_module_default()).storeImg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/images/play_store.png",
                                            className: (HomeUI_module_default()).storeImg
                                        })
                                    }),
                                    ((0,helperFunctions/* isIOS */.gn)() || !(0,helperFunctions/* isAndroid */.Dt)() || !isBrowser) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://apps.apple.com/in/app/namaspay/id6449447184",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: (HomeUI_module_default()).storeImg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/images/app_store.png",
                                            className: (HomeUI_module_default()).storeImg
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/images/hero.webp",
                        className: (HomeUI_module_default()).img
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomeUI_module_default()).sec2Wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((HomeUI_module_default()).sec2, " pagePad__x"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HomeUI_module_default()).desc,
                            children: "Accepting currencies from around the globe"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((HomeUI_module_default()).flagsAnimationContainer, " marginTop--l3"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HomeUI_module_default()).flagsAnimation,
                                children: arrayOf1000Length === null || arrayOf1000Length === void 0 ? void 0 : arrayOf1000Length.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/icons/flags.png"
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomeUI_module_default()).sec3Wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((HomeUI_module_default()).sec3, " pagePad__x"),
                    children: [
                        isMobile() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sectionHeading text__align--center marginBottom--l4",
                                    children: [
                                        "Welcome to",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        welcomeToTextList === null || welcomeToTextList === void 0 ? void 0 : welcomeToTextList[welcomeToTextIndex]
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "width--full",
                                    src: "/assets/images/hero_mobile.png?v=2"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "position--relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "width--full",
                                    src: "/assets/images/hero_desktop.png?v=3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((HomeUI_module_default()).welcomeToText, " sectionHeading"),
                                    children: [
                                        "Welcome to",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        welcomeToTextList === null || welcomeToTextList === void 0 ? void 0 : welcomeToTextList[welcomeToTextIndex]
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((HomeUI_module_default()).desc, " marginTop--l5"),
                            children: "With NamasPay, you can:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((HomeUI_module_default()).usageWidgetRow, " marginTop--l4"),
                            children: upiUsages === null || upiUsages === void 0 ? void 0 : upiUsages.map(function(item, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUI_module_default()).usageWidget,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (HomeUI_module_default()).img,
                                            src: item.img,
                                            alt: "UPI usage image"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (HomeUI_module_default()).title,
                                            children: item === null || item === void 0 ? void 0 : item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).desc,
                                            children: item === null || item === void 0 ? void 0 : item.desc
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sectionHeading textAlign--center--mobile",
                            style: {
                                marginTop: 96
                            },
                            children: "India runs on UPI"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((HomeUI_module_default()).upiFeaturesContainerWrapper, " marginTop--l4"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HomeUI_module_default()).upiFeaturesContainer,
                                children: upiFeatures.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (HomeUI_module_default()).upiFeatureWidget,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (HomeUI_module_default()).featureImg,
                                                style: {
                                                    backgroundImage: "url('".concat(item.img, "')")
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "".concat((HomeUI_module_default()).desc, " marginTop--l3"),
                                                children: item.title
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "sectionHeading textAlign--center--mobile",
                            style: {
                                marginTop: 92
                            },
                            children: [
                                "Safer than Cash,",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "better than a card"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((HomeUI_module_default()).comparisonContainer, " marginTop--l4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUI_module_default()).comparisonRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col1,
                                            children: "Benefits"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col2,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex--center--center flex__flow--column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/icons/cash.svg",
                                                        style: {
                                                            width: 20
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            marginTop: 4
                                                        },
                                                        children: "Cash"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col3,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex--center--center flex__flow--column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/icons/card.svg",
                                                        style: {
                                                            width: 20
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            marginTop: 4
                                                        },
                                                        children: "Card"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex--center--center flex__flow--column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/icons/logo.svg?v=2",
                                                        style: {
                                                            width: 20
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            marginTop: 4
                                                        },
                                                        children: "NamasPay"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUI_module_default()).comparisonRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (HomeUI_module_default()).col1,
                                            children: "Zero fee on every payment"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col2,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icons/check.svg",
                                                style: {
                                                    width: 20
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col3,
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icons/check-circle.svg",
                                                style: {
                                                    width: 20
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUI_module_default()).comparisonRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (HomeUI_module_default()).col1,
                                            children: "Accepted everywhere in India"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col2,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icons/check.svg",
                                                style: {
                                                    width: 20
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col3,
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icons/check-circle.svg",
                                                style: {
                                                    width: 20
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUI_module_default()).comparisonRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (HomeUI_module_default()).col1,
                                            children: "Secured against getting lost or stolen"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col2,
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col3,
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icons/check-circle.svg",
                                                style: {
                                                    width: 20
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUI_module_default()).comparisonRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (HomeUI_module_default()).col1,
                                            children: "Fast and convenient online payments"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col2,
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((HomeUI_module_default()).col3, " flex__flow--column"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/icons/check.svg",
                                                    style: {
                                                        width: 20
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        fontSize: 8
                                                    },
                                                    children: "(Lengthy process)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icons/check-circle.svg",
                                                style: {
                                                    width: 20
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUI_module_default()).comparisonRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (HomeUI_module_default()).col1,
                                            children: "Easily track your spends"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col2,
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col3,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icons/check.svg",
                                                style: {
                                                    width: 20
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).col4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icons/check-circle.svg",
                                                style: {
                                                    width: 20
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeUI_module_default()).safeMoneyContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUI_module_default()).details,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "sectionHeading textAlign--center--mobile",
                                            children: [
                                                "Safe money,",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "safer travels"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "marginTop--l6",
                                            children: quickFeatures.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex--center--center",
                                                    style: {
                                                        background: "#F7F7F7",
                                                        borderRadius: 25,
                                                        marginTop: index > 0 ? 32 : 0,
                                                        padding: 32
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: item.img,
                                                            alt: "App safety image",
                                                            style: {
                                                                width: 64
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "".concat((HomeUI_module_default()).desc, " flex--1 marginLeft--l3"),
                                                            children: item.title
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: (HomeUI_module_default()).img,
                                    src: "/assets/images/safe_money.png?v=2",
                                    alt: "Safe money creative"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomeUI_module_default()).sec4Wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((HomeUI_module_default()).sec4, " pagePad__x"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((HomeUI_module_default()).sectionHeading, " sectionHeading textAlign--center--mobile"),
                            children: "Powered by"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeUI_module_default()).imgsWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icons/NPCI.svg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icons/UPI.svg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icons/trio-logo.svg",
                                    style: {
                                        marginTop: -5
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomeUI_module_default()).sec5Wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((HomeUI_module_default()).sec5, " pagePad__x"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HomeUI_module_default()).sec5Widget,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HomeUI_module_default()).imgWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/across-country.webp"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HomeUI_module_default()).details,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sectionHeading textAlign--center--mobile",
                                        children: "NamasPay your way across the country"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((HomeUI_module_default()).acrossCountryListWrapper, " marginTop--l4"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeUI_module_default()).acrossCountryList,
                                            children: arrayOf100Length === null || arrayOf100Length === void 0 ? void 0 : arrayOf100Length.map(function() {
                                                return acrossCountryList === null || acrossCountryList === void 0 ? void 0 : acrossCountryList.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: item
                                                    }, index);
                                                });
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((HomeUI_module_default()).desc, " marginTop--l10"),
                                        children: "From arrival to departure, NamasPay's got you covered."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "marginTop--l4 display--flex flex__justifyContent--start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA/* default */.Z, {
                                            type: "secondary",
                                            text: isDesktop() ? "Download Now" : "Download Now",
                                            onAction: helperFunctions/* onDownloadClick */.No
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomeUI_module_default()).sec6Wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((HomeUI_module_default()).sec6, " pagePad__x"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeUI_module_default()).imgWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sectionHeading textAlign--center--mobile",
                                    children: "Getting started with NamasPay"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/getting_started.png?v=2",
                                    className: "width--full marginTop--l4"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HomeUI_module_default()).details,
                            children: gettingStarted === null || gettingStarted === void 0 ? void 0 : gettingStarted.map(function(item, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUI_module_default()).widget,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex--center--center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((HomeUI_module_default()).title, " flex--1 marginRight--l3"),
                                                    children: item === null || item === void 0 ? void 0 : item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item === null || item === void 0 ? void 0 : item.img,
                                                    style: {
                                                        width: 36,
                                                        height: 36
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((HomeUI_module_default()).desc, " marginTop--l3"),
                                            children: item === null || item === void 0 ? void 0 : item.desc
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomeUI_module_default()).faqWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((HomeUI_module_default()).faqContainer, " pagePad__x"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportSection/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "faq",
                            className: "sectionHeading textAlign--center--mobile marginTop--l10",
                            children: "FAQs"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "marginTop--l4",
                            children: faqConstants/* allFAQs.map */.o.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((HomeUI_module_default()).faqWidget, " ").concat(index > 0 ? "marginTop--l3" : ""),
                                    onClick: function() {
                                        return setOpenedFaqIndex(index === openedFaqIndex ? -1 : index);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "display--flex flex__justifyContent--between flex__alignItems--center cursor--pointer",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (HomeUI_module_default()).desc,
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/icons/downArrow.svg",
                                                    alt: "Down arrow icon",
                                                    style: {
                                                        rotate: index === openedFaqIndex ? "180deg" : "0deg",
                                                        marginLeft: 8
                                                    }
                                                })
                                            ]
                                        }),
                                        index === openedFaqIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((HomeUI_module_default()).desc, " marginTop--l4 padTop--l4"),
                                            style: {
                                                borderTop: "1px solid rgba(0,0,0,0.05)",
                                                color: "#7c7c7c"
                                            },
                                            dangerouslySetInnerHTML: {
                                                __html: item.desc
                                            }
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var components_HomeUI = (HomeUI);

// EXTERNAL MODULE: ./constants/metaConstants.js
var metaConstants = __webpack_require__(7202);
;// CONCATENATED MODULE: ./pages/index.js
// Libraries




// Components

// Constants

function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaConstants/* META_INFO.DEFAULT_TITLE */.f.DEFAULT_TITLE,
                        name: "twitter:title"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaConstants/* META_INFO.DEFAULT_URL */.f.DEFAULT_URL,
                        name: "twitter:url"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: metaConstants/* META_INFO.DEFAULT_TITLE */.f.DEFAULT_TITLE,
                canonical: metaConstants/* META_INFO.DEFAULT_URL */.f.DEFAULT_URL,
                openGraph: {
                    title: metaConstants/* META_INFO.DEFAULT_TITLE */.f.DEFAULT_TITLE,
                    url: metaConstants/* META_INFO.DEFAULT_URL */.f.DEFAULT_URL
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* WebPageJsonLd */.VL, {
                id: metaConstants/* META_INFO.DEFAULT_URL */.f.DEFAULT_URL,
                description: metaConstants/* META_INFO.LONG_DESC */.f.LONG_DESC
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HomeUI, {})
        ]
    });
};


/***/ }),

/***/ 7274:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"HomeUI_headerWrapper___nauh","header":"HomeUI_header__yQ7P7","downloadCTA":"HomeUI_downloadCTA__LNsRz","title":"HomeUI_title__2YcTz","desc":"HomeUI_desc__q_oUd","sec3Wrapper":"HomeUI_sec3Wrapper___igt3","sec3":"HomeUI_sec3__kotDB","comparisonContainer":"HomeUI_comparisonContainer__BnBHn","comparisonRow":"HomeUI_comparisonRow__HWCvn","col1":"HomeUI_col1__NPcZA","sec1":"HomeUI_sec1__Udx3W","details":"HomeUI_details__zHmRo","pageTitle":"HomeUI_pageTitle__DblKZ","storeImagesWrapper":"HomeUI_storeImagesWrapper__AsT_K","storeImg":"HomeUI_storeImg__cwF9n","img":"HomeUI_img__wr61b","sec2Wrapper":"HomeUI_sec2Wrapper__9F0Dp","sec2":"HomeUI_sec2__1oD_8","flagsAnimationContainer":"HomeUI_flagsAnimationContainer__0iL4g","flagsAnimation":"HomeUI_flagsAnimation__MI930","run":"HomeUI_run__zEBA4","welcomeToText":"HomeUI_welcomeToText__MPG2m","usageWidgetRow":"HomeUI_usageWidgetRow__r_9xq","usageWidget":"HomeUI_usageWidget__qhtob","upiFeaturesContainerWrapper":"HomeUI_upiFeaturesContainerWrapper__LdAM_","upiFeaturesContainer":"HomeUI_upiFeaturesContainer__6huwu","upiFeatureWidget":"HomeUI_upiFeatureWidget__f6AJt","featureImg":"HomeUI_featureImg__jkEbn","col2":"HomeUI_col2__3VpYf","col3":"HomeUI_col3__f3C0n","col4":"HomeUI_col4__KtU6j","safeMoneyContainer":"HomeUI_safeMoneyContainer__rKH36","sec4Wrapper":"HomeUI_sec4Wrapper__8p5Nc","sec4":"HomeUI_sec4__UNs6M","sectionHeading":"HomeUI_sectionHeading__v0wV_","imgsWrapper":"HomeUI_imgsWrapper__KCJXg","sec5Wrapper":"HomeUI_sec5Wrapper__ZSYE6","sec5":"HomeUI_sec5__ySaqh","sec5Widget":"HomeUI_sec5Widget__WubTd","imgWrapper":"HomeUI_imgWrapper__dWwzu","acrossCountryListWrapper":"HomeUI_acrossCountryListWrapper__NLWtP","acrossCountryList":"HomeUI_acrossCountryList__bwW1q","acrossCountryRun":"HomeUI_acrossCountryRun__JmtHx","sec6Wrapper":"HomeUI_sec6Wrapper__XXxDI","sec6":"HomeUI_sec6__IAkGG","widget":"HomeUI_widget__hLe1m","faqWrapper":"HomeUI_faqWrapper__8yi6e","faqContainer":"HomeUI_faqContainer__muFWf","faqWidget":"HomeUI_faqWidget__BIPpQ","supportContainer":"HomeUI_supportContainer__LUmWB","footerWrapper":"HomeUI_footerWrapper__Xa_Rg","footer":"HomeUI_footer__wvlfA","footerLink":"HomeUI_footerLink__HLbvS"};

/***/ }),

/***/ 653:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customCta":"CTA_customCta__k8Ay7","secondary":"CTA_secondary__hCi_W"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);